import Insight from "../insightClass";
import React from "react";
import { insight41Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight072 = new Insight(
  "17 October 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight41Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-10-17)",
  "",
  `Eight extra-large monopiles — each ~2,300 tonnes — have arrived at the Port of Leith for the 1.1 GW Inch Cape Offshore Wind Farm, marking the start of a heavy construction phase that will run through 2026. The port, redeveloped under a £150 million programme (with ~£50 million linked to Inch Cape), has stood up quayside capacity and the Charles Hammond Berth to handle the world’s largest offshore vessels.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-10-17)</h1>
    <h2></h2>
    <p className="article-date">17 October 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>
    <h3>
      1. Scotland’s Inch Cape hits major milestone as XXL monopiles arrive at
      Port of Leith (UK)
    </h3>
    <p>
      Eight extra-large monopiles — each ~2,300 tonnes — have arrived at the
      Port of Leith for the 1.1 GW Inch Cape Offshore Wind Farm, marking the
      start of a heavy construction phase that will run through 2026. The port,
      redeveloped under a £150 million programme (with ~£50 million linked to
      Inch Cape), has stood up quayside capacity and the Charles Hammond Berth
      to handle the world’s largest offshore vessels. Monopiles are supplied by
      CWHI, which the project says delivered “on time, within budget” after more
      than a million safe work hours. The current logistics plan foresees a
      total of 54 XXL monopiles and transition pieces plus 18 jackets staged
      through Leith ahead of Jan De Nul’s installation campaign. Turbine scope
      is 72 × 15 MW machines and a single offshore substation already installed
      earlier in August. First power is targeted for late 2026 with full
      commissioning in 2027, and site employment will ramp above 100 during peak
      port operations. The milestone also showcases Leith’s positioning as a
      Scottish renewables hub able to support multiple North Sea projects over
      the medium term.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      For UK content and supply-chain security, this is a high-signal proof
      point: Scottish port infrastructure is now handling XXL foundations at
      scale, de-risking future Scottish and UK projects that depend on
      heavy-lift laydown and marshalling. Leith’s readiness broadens port
      optionality — critical for contracting strategies that split foundations,
      towers and blades across multiple hubs. Expect near-term bid strategies to
      lean harder on Scottish ports, shortening wet-tow legs and improving
      weather windows — a material LCOE lever when installation spreads are
      tight.
    </p>
    <h3>
      2. Ming Yang proposes up to £1.5 bn Scottish factory; UK weighs energy
      security vs supply-chain scale
    </h3>
    <p>
      Ming Yang Smart Energy set out plans to invest up to £1.5 bn (~$2 bn) to
      build a turbine manufacturing complex at Ardersier Port near Inverness,
      with phase-one nacelle and blade output targeted for late 2028 and as many
      as 1,500 jobs in early stages. Subsequent phases would expand to floating
      wind components and controls. The proposal follows MoUs with UK
      stakeholders, including Octopus, and ongoing discussions with UK/Scottish
      authorities. The project aligns with Britain’s push to onshore more of the
      offshore wind supply chain — particularly for floating — yet faces
      national-security scrutiny of Chinese industrial participation in critical
      infrastructure. The Scottish Government is supportive given the floating
      pipeline in the Celtic and North Seas, while Westminster is still
      reviewing risks and potential conditionality. If approved, the plant would
      be strategically placed to serve ScotWind, INTOG and future CfD rounds,
      potentially easing nacelle/blade bottlenecks around 2028–2032 and
      improving GBP-denominated content for UK bids.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      From a commercial lens, UK-based nacelle/blade capacity could shave
      logistics costs and FX risk and help bidders earn ‘supply-chain
      development’ points. The gating item is policy certainty: investors will
      look for visibility on CfD Round 7/8 volumes, inflation indexation and
      floating-specific support. If permitted, we expect co-investment
      structures — possibly including Great British Energy — to de-risk capex.
      European OEMs may respond by reinforcing local footprints or doubling down
      on proprietary 18–20 MW platforms to defend share.
    </p>
    <h3>
      3. Netherlands opens 1 GW Nederwiek I-A tender, with ecology and grid fit
      central
    </h3>
    <p>
      The Dutch government has launched the long-trailed tender for the 1 GW
      Nederwiek I-A site in the North Sea. Bids close on 30 October, with a
      winner due next spring and earliest construction from 2030. In a shift
      from pure price competition, the comparative assessment weighs ecological
      impact and alignment with TenneT’s Nederwiek 1 platform, aiming to de-risk
      integration and minimise system costs. The state previously cut the
      initial two-site offering down to one to maintain competitiveness amid
      tighter capital and supply-chain conditions. The new Offshore Wind Energy
      Action Plan announced last month sets the broader pipeline context and
      seeks to accelerate auction readiness after a year in which European
      tenders increasingly prioritised non-price criteria such as system value
      and biodiversity. For developers, success will turn on credible
      nature-positive proposals (e.g., seabed and species mitigation), robust
      grid compatibility plans, and bankable execution schedules that reflect
      vessel and component availability around 2029–2032. The tender’s design
      continues a Benelux trend of coupling seabed rights to clear grid
      interfaces, shortening the time from award to FID by clarifying connection
      scope early.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      Expect strong interest from incumbents with Dutch track records and
      OEM-anchored consortia who can evidence low-impact foundation concepts and
      data-driven wildlife strategies. The comparative approach likely favours
      players with established environmental monitoring toolkits and access to
      next-gen installation vessels. With 2030 as earliest build, bid models
      must price in falling but still elevated capex, stabilising interest
      rates, and a maturing merchant/PPAs stack beyond the CfD archetype. Watch
      for proposals that co-optimise wake effects and cable routes to squeeze a
      few extra percentage points of net capacity factor — small deltas that can
      win on tie-breakers.
    </p>
    <h3>
      4. DEME takes delivery of next-gen WTIV ‘Norse Wind’, targeting 300 m
      rotor machines (Belgium)
    </h3>
    <p>
      Belgium’s DEME has welcomed the wind turbine installation vessel (WTIV)
      Norse Wind from CIMC Raffles. The jack-up features a 3,200-tonne main
      crane and is specified for the “next generation” of very large turbines —
      up to ~3,000-tonne components and rotor diameters around 300 m. DEME
      indicates early-2026 commissioning for fleet integration, with both Norse
      Wind and sister Norse Energi slated for RWE’s 1.6 GW Nordseecluster once
      fully online. Delivery adds crucial high-hook-height capability to the
      European vessel pool at a time when nacelle masses, hub heights and blade
      lengths continue to step up, and when schedule certainty for 15–20 MW
      class machines is a differentiator in bids. The vessel’s arrival also
      partially offsets recent uncertainty around the U.S. WTIV pipeline,
      underscored by a separate cancellation. For European developers,
      additional heavy-lift capacity can de-risk 2027–2029 campaigns, reduce
      weather-delay exposure, and compress installation timelines — important
      for projects with tight subsidy windows or grid delivery milestones.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      WTIV scarcity premiums have eased but not disappeared. Norse Wind will
      command strong day rates in peak seasons, especially for floating
      pre-assembly scopes that need high deck loads and smart logistics. Expect
      chartering strategies to bundle monopile or jacket campaigns with early
      turbine slots to lock in priority. For OEMs and developers, iterative LCOE
      gains will come from pairing vessels like Norse Wind with larger feeder
      barges, optimised marshalling, and blade-by-blade lift strategies that
      reduce idle time.
    </p>
    <h3>
      5. 50Hertz awards Njord Survey long-term geophysical/ROV framework for
      Baltic Sea build-out (Germany)
    </h3>
    <p>
      Transmission system operator 50Hertz has awarded Sweden’s Njord Survey a
      long-term framework to deliver geophysical and ROV seabed surveys across
      Germany’s Baltic projects. The scope underpins early-stage design, route
      engineering and risk management for export cables and grid-connection
      assets tied to Berlin’s accelerated offshore targets. 50Hertz recently
      announced a new offshore hub at Rostock to support Baltic renewables,
      signalling a pipeline of seabed campaigns through the middle of the
      decade. Njord says it will deploy advanced sensors and ROV platforms aimed
      at high-resolution data capture to de-risk design changes and compress
      consent-to-construction timelines. For Germany, the award lands amid a
      broader policy shift toward more pragmatic procurement tools, including
      discussion of CfDs, after a difficult tender outcome earlier in 2025. For
      survey and site-investigation supply chains, multi-year frameworks help
      smooth vessel and equipment utilisation, anchoring talent and capital in
      the region.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      Quality of early geodata is a lead indicator for cost and schedule
      performance. The 50Hertz–Njord deal supports a “front-loaded” project
      model: higher spend on site characterisation to avoid late-stage surprises
      (UXO, boulders, mobile bedforms). Developers planning Baltic exposure
      should benchmark survey specs and data delivery standards to ensure
      downstream EPC interfaces (cables/foundations) receive decision-grade
      datasets, reducing change orders and weather-risked re-runs.
    </p>
    <h3>
      6. RWE hails ‘world-first’ cargo-drone logistics cutting offshore
      transport times by half (Germany/UK North Sea)
    </h3>
    <p>
      RWE reported multi-phase trials using long-range autonomous and short-hop
      cargo drones to deliver tools and small components at sea to projects
      including Nordsee Ost and Arkona. Working with Skyways, Skyports Drone
      Services and Ampelmann, the latest three-week German trial (September)
      flew regular sorties from Mukran Port (~25+ miles) to Arkona, autonomously
      locking onto the nacelle and executing automated cargo drops of up to ~10
      kg. RWE says flight times were under 30 minutes versus ≥1 hour by crew
      transfer vessel (CTV), effectively halving turnaround for time-critical
      parts. Beyond latency and cost, the operator emphasises safety and
      emissions benefits, and suggests drones could become an integrated O&M
      tool across its global fleet. While payloads are modest, the use-case
      targets chronic O&M delays (missing consumables, small spares) that can
      strand high-value technicians offshore. The company frames the approach as
      complementary to CTV/SOV logistics, not a replacement.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      This is an OPEX and availability play. For multi-GW fleets, even
      single-digit percentage improvements in turbine uptime drive meaningful
      revenue. Expect follow-on: BVLOS regulatory pathways, heavier-lift
      airframes (25–100 kg), and integration with digital work packs/CMMS.
      Developers should run sensitivity cases in O&M models: drone capex/opex vs
      avoided vessel hours, safety exposure and weather-window risk.
      Port-of-call readiness (charging, airspace procedures) becomes part of
      site selection and port contracting.
    </p>
    <h3>
      7. Brazil pushes first offshore wind auction beyond 2026, fraying investor
      patience (Brazil)
    </h3>
    <p>
      Brazil’s National Energy Policy Council has formed a new working group to
      clarify federal offshore wind rules but granted roughly nine months to
      produce legislation, implying that the earliest possible auction would
      fall in H2 2026 — right in the middle of an election year. Industry voices
      fear further drift, with some citing stalled analysis of consultation
      feedback on area-selection methodologies that would guide the decree. The
      timing risk lands just as international capital is looking for alternative
      growth theatres given turbulence in parts of the U.S. market. Analysts
      note that a slippage beyond 2026 would push grid-tie and port investments
      to the right, increasing the risk that supply-chain capacity is allocated
      to earlier-moving markets. The government has signalled intent to
      integrate technical, environmental, social and economic criteria in area
      selection, but uncertainty around both the decree and auction calendar is
      dampening near-term FID prospects. Investors warn that missed windows
      could raise Brazil’s cost of capital as developers price policy risk into
      bids.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      We advise clients to treat Brazil as an options market for now: maintain
      site control and stakeholder workstreams, but gate major spend to hard
      milestones (decree issuance, auction calendar, TSO frameworks). Hedge
      execution risk by pairing Brazil exposure with faster-moving APAC/EMEA
      pipelines to keep installation spreads utilised and OEM slots secured
      through 2028–30.
    </p>
    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
